import { persistentReducedStream } from '@ardoq/rxbeach';
import { Observable, distinctUntilChanged, map } from 'rxjs';
import { isEqual } from 'lodash';
import { OrgUsersById, OrgUsersStreamShape } from './types';
import { reducers } from './reducers';

export const defaultState: OrgUsersStreamShape = {
  users: [],
  byId: {},
  error: null,
};

/**
 * Stream that contains all users in the organization (including contributors).
 */
export const orgUsers$ = persistentReducedStream(
  'orgUsers$',
  defaultState,
  reducers
);

/**
 * The org-users `byId` lookup for pure user-label resolution — the
 * `formatUserField` path in tabview, and `getUserLabelAsync` in
 * `search/QueryBuilderWithSuggestionsLoaders`.
 *
 * `fetchedOrgUsersSuccessReducer` rebuilds `byId` on every `fetchOrgUsers()`, so the
 * reference changes even when the user list is byte-identical. The `distinctUntilChanged`
 * guard keeps a stable reference across such refetches; consume this rather than an
 * inline `orgUsers$.pipe(map(({ byId }) => byId))` arm, which relayouts on every refetch.
 */
export const orgUsersById$: Observable<OrgUsersById> = orgUsers$.pipe(
  map(({ byId }) => byId),
  distinctUntilChanged(isEqual)
);
